import React from "react"
import types from "prop-types"
import { FormsyTextInput } from "shared/inputs"

const GroupName = ({ group }) => {
  const { id } = group

  const inputId = `group-${id}-name-input`

  return (
    <div>
      <label htmlFor={inputId}>Name</label>
      <FormsyTextInput
        uuid={inputId}
        className="bordered-base-input text-sm"
        name="name"
        placeholder="Name"
        value={group.name || ""}
        required
        validations={{ isNotBlankString: true }}
        validationErrors={{ isDefaultRequiredValue: "required" }}
      />
    </div>
  )
}

GroupName.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  group: types.object.isRequired,
}

export default GroupName
